import { createSelector } from "@reduxjs/toolkit"
import type { AnimationI } from "tweenly"
import { ObjectsStateT } from "../../objects.slice"

/**
 * `animationId -> animation`, built once per change of `objects.value`.
 *
 * `selectAnimationById` walks every object and every animation on each call and allocates a
 * fresh array while doing it. That is fine once, but it was being called from inside a
 * `.sort()` comparator in TimelineRowWrapper — so every timeline row paid
 * O(a · log a · (objects + animations)) on every render, and a render happens on every object
 * change, including the end of every drag.
 */
export const selectAnimationsMap = createSelector(
    [(objects: ObjectsStateT) => objects.value],
    (objectsById): ReadonlyMap<string, AnimationI> => {
        const animations = new Map<string, AnimationI>()
        Object.values(objectsById).forEach((object) => {
            if (!object?.animations) return
            Object.values(object.animations).forEach((animation) => {
                if (animation) animations.set(animation.id, animation)
            })
        })
        return animations
    }
)
